/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState, useRef } from "react"
import clsx from "clsx"
import types from "prop-types"
import { useOnClickOutside, useTabNavigationWithKeyboard } from "hooks"

const Tabs = ({ className = "", initialActiveSlug = null, children }) => {
  const [tabNavOpen, setTabNavOpen] = useState(false)
  const openTabNav = () => setTabNavOpen(true)
  const closeTabNav = () => setTabNavOpen(false)

  const tabNavRef = useRef()
  useOnClickOutside(tabNavRef, closeTabNav)

  const [navIsHorizontal, setNavIsHorizontal] = useState(window.innerWidth >= 1024)
  const {
    activeIndex, tabRef, changeActiveTab, handleKeyDown,
  } = useTabNavigationWithKeyboard(children.map(({ props }) => props), initialActiveSlug)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setNavIsHorizontal(true)
      } else {
        setNavIsHorizontal(false)
      }
    }
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const { props: { children: activeTabContent } } = children[activeIndex] || children[0]

  return (
    <>
      <nav
        className="tab-nav-container"
        aria-labelledby="tab-navigation"
      >
        <div className="lg:hidden text-sm font-medium text-dark mb-1">
          <span id="tab-navigation">Navigation</span>
        </div>
        <svg className="tab-nav-icon"><use xlinkHref={tabNavOpen ? "#chevron-up" : "#chevron-down"} /></svg>
        <ul
          ref={tabNavRef}
          className={clsx(className, "tab-nav", tabNavOpen && "open")}
          onClick={tabNavOpen ? closeTabNav : openTabNav}
          role={navIsHorizontal ? "tablist" : "menu"}
          aria-orientation={navIsHorizontal ? "horizontal" : "vertical"}
          aria-labelledby="submission-id-slug"
        >
          {
            children.map(({ props }, index) => {
              const {
                title, NotificationBadge, tabId, tabPanelId,
              } = props
              const isActiveTab = index === activeIndex

              return (
                <li
                  key={title}
                  className={clsx(isActiveTab && "active", "tab-link")}
                  role="presentation"
                >
                  <button
                    id={tabId}
                    className={clsx(isActiveTab && "active")}
                    tabIndex={isActiveTab ? 0 : -1}
                    onClick={(e) => changeActiveTab(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    role={navIsHorizontal ? "tab" : "menuitem"}
                    aria-selected={isActiveTab}
                    ref={(el) => {
                      tabRef.current[index] = el
                    }}
                    aria-controls={tabPanelId}
                  >
                    <span
                      className={clsx(NotificationBadge && "mr-2")}
                    >
                      {title}
                    </span>
                    {NotificationBadge && <NotificationBadge />}
                  </button>
                </li>
              )
            })
          }
        </ul>
      </nav>
      {activeTabContent}
    </>
  )
}

Tabs.propTypes = {
  initialActiveSlug: types.string,
  className: types.string,
  children: types.node.isRequired,
}

export default Tabs
